import React from "react";

function Disclaimer() {
  return (
    <div className="px-4 text-gray-400 font-semibold">
      <p className="text-[7px] ">
        <strong className=" text-gray-500">Disclaimer:</strong> This document is prepared based on the data
        submitted by member institutions of CRIF High Mark Credit Information
        Services Private Limited (CRIF High Mark) and by using the proprietary
        match logic of CRIF High Mark. No alterations are made to the data
        submitted by member institutions and the same is up to date as well as
        accurate to the best of its knowledge. By using data contained in this
        document, the user acknowledges that CRIF High Mark is not responsible
        for errors/omissions resulting from submission of erroneous data from
        Members to CRIF High Mark. This document may not be used or disclosed to
        others, except with the written permission of CRIF High Mark. Any paper
        copy of this document will be considered uncontrolled. If you are not
        the intended recipient, you are not authorized to read, print, retain,
        copy, disseminate, distribute or use this information or any part
        thereof. PERFORM score provided in this document is joint work of CRIF
        SPA (Italy) and CRIF High Mark (India). For any assistance on this
        report, reach out to us at: customerservice@crifhighmark.com
      </p>

      <div className="grid grid-cols-3 pt-2 text-[8px]">
        <p>© Copyright 2025. All rights reserved</p>
        <p>CRIF High Mark Credit Information Services Pvt. Ltd</p>
        <p>Confidential</p>
      </div>
    </div>
  );
}

export default Disclaimer;
